import { Component, EventEmitter, Inject, Output, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BackOfficeService } from '../../../../../services/backoffice.service';
import { BackOffice24UsersAddComponent } from '../back-office24-users-add/back-office24-users-add.component';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-back-office24-add-organization',
  standalone: false,
  templateUrl: './back-office24-add-organization.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './back-office24-add-organization.component.css'
})

export class BackOffice24AddOrganizationComponent {
  @Output() saveChangesEvent = new EventEmitter<any>();
  organizationForm: UntypedFormGroup;
  isLoading: boolean = false;
  organizationTypes: string[] = ["None", "ParkingOperator", "TravelAgency", "ShuttleCustomer", "ServicePerformer", "ParkingCompany"];

  constructor(
    private backOfficeService: BackOfficeService,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private translate: TranslocoService,
    @Inject(MatDialogRef<BackOffice24UsersAddComponent>) private dialogRef: MatDialogRef<BackOffice24UsersAddComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      organizationId: number,
    }) { }

  ngOnInit(): void {
    this.addOrganizationForm();
  }

  addOrganizationForm() {
    this.organizationForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      type: ['', [Validators.required]],
      parentOrganizationId: this.data.organizationId,
    });
  }

  saveChanges(event?: Event): void {
    if (event) {
      event.preventDefault();
    }

    if (this.organizationForm.invalid) {
      return;
    }

    this.isLoading = true;

    const payload = {
      Name: this.organizationForm.get('name')?.value,
      Type: this.organizationForm.get('type')?.value,
    };
    this.backOfficeService.createOrUpdateOrganization((this.data.organizationId).toString(), payload).pipe()
      .subscribe({
        next: organization => {
          const message = this.translate.translate('USER_MANAGEMENT.ORGANIZATION_CREATION_SUCCESS');
          this.isLoading = false;
          this.dialogRef.close();
          this.snackBar.open(message, 'OK', { duration: 3000, verticalPosition: 'top' });
          this.saveChangesEvent.emit({ organization: organization });
        },
        error: error => {
          const message = this.translate.translate('USER_MANAGEMENT.ORGANIZATION_CREATION_FAILED');
          console.error('Error creating organization:', error);
          this.isLoading = false;
          this.snackBar.open(message, 'OK', { duration: 3000, verticalPosition: 'top' });
        }
      });
  }
}

export enum OrganizationType {
  None = 0,
  ParkingOperator = 1,
  TravelAgency = 2,
  ShuttleCustomer = 4,
  ServicePerformer = 8,
  ParkingCompany = 16
}
